import type { UseQueryResult } from '@tanstack/react-query';
import { useBasicQuery } from '@hooks/requests/utils/use_basic_query';
import { PARTNER_TEAM_INVITATIONS_PATH } from '@hooks/requests/utils/paths';

/**
 * A pending invitation for the caller's own organization, as returned by
 * `GET /api/v1/partner/team/invitations` (BR-008). Distinct from
 * `DashboardMember` — the invitee holds no membership and no role until
 * they accept.
 */
export interface PendingInvitation {
  invitationId: string;
  email: string;
  role: string;
  createdAt: string | null;
}

export interface UsePartnerTeamInvitationsParams {
  enabled?: boolean;
}

export const usePartnerTeamInvitationsQuery = ({
  enabled = true,
}: UsePartnerTeamInvitationsParams = {}): UseQueryResult<PendingInvitation[], Error> =>
  useBasicQuery<PendingInvitation[]>(PARTNER_TEAM_INVITATIONS_PATH, undefined, { enabled });

export default usePartnerTeamInvitationsQuery;
